import React, { Component } from "react";
import axios from "../../../axios";
import qs from "qs";
import Alert from "react-s-alert";
import FormDropdown from "../../../components/FormDropdown";
import { status_aktif } from "../../../constants/general";
import DropdownView from "./DropdownView";
import {
	QUESTION_LIST,
	QUESTION_SUBMIT_ADD,
	QUESTION_SUBMIT_EDIT
} from "../endpoints";

class Forms extends Component {
	constructor(props) {
		super(props);

		this.state = {
			exam_cat_id: "",
			exam_cat_name: "",
			question_text: "",
			option: [],
			isButtonLoading: false,
			isLoading: false,
			option_count: "",
			question_type:"",
			option_match_text:"",
			score:""
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeScoreEssay = this.handleChangeScoreEssay.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}

	handleChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		if (this.props.mode === "Tambah") {
			if (this.state.question_type !== "essay") {
				if (this.state.question_type !== "match") {
					let newState = [];

					for (var i = 0; i < value; i++) {
						newState.push({ option_text: "", score:"" });
					}

					this.setState({ option: newState });
				}else{
					let newState = [];

					for (var i = 0; i < value; i++) {
						newState.push({ option_text: "",option_match_text: "", score:"" });
					}

					this.setState({ option: newState });
				}
				
			}
		}

		const newState = {
			[name]: value
		}

		if (name === "question_type") {
			newState.option_count = ""
		}

		this.setState(newState);
	}

	handleSubmit() {
		this.setState({ isButtonLoading: true });

		const url =
			this.props.mode === "Tambah" ? '/exam/create-soal' : '/exam/update-soal';

		const qOption = JSON.stringify(this.state.option);

		let newState = {
			locale:"id",
			platform:"web",
			question_type:this.state.question_type,
			exam_id: this.props.match.params.exam_id,
			question_text: this.state.question_text,
		};

		if (this.state.question_type !== 'essay') {
			newState.option=qOption
		}else{
			newState.score=this.state.score
		}



		if (this.props.mode === "Edit") {
			newState.question_id = this.props.match.params.question_id;
		}

		axios({
			method: "post",
			url: url,
			data: qs.stringify(newState)
		})

		.then(response => {
			const result = response.data;

			if (result.status) {
				Alert.success(result.text);
				this.props.history.replace(
					"/exam/question/" + this.props.match.params.exam_id
				);
			} else {
				if (Array.isArray(result.text)) {
					result.text.map(item => {
						Alert.error(item);

						return true;
					});
				} else {
					Alert.error(result.text);
				}

				this.setState({ isButtonLoading: false });
			}
		})
		
		.catch(error => {
			console.log(error);
			this.setState({ isButtonLoading: false });
			Alert.error("Gagal terhubung ke server!");
		});
	}

	handleChangeOptionText(event, index) {
		let newState = [...this.state.option];

		newState[index].option_text = event.target.value;

		this.setState({
			option: newState
		});
	}

	handleChangeOptionMatchText(event, index) {
		let newState = [...this.state.option];

		newState[index].option_match_text = event.target.value;

		this.setState({
			option: newState
		});
	}

	handleChangeOptionScore(event, index) {
		let newState = [...this.state.option];
		
		this.setState({
			option: newState
		});
	}

	handleChangeScoreEssay(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	loadData() {
		if (this.props.mode === "Edit") {
			this.setState({ isLoading: true });

			const params = qs.stringify({
	            locale:"id",
	            platform:"web",
	            question_id:this.props.match.params.question_id
	        })

			axios({
				method: "post",
				url: "/exam/exam-detail-soal?" + params
			})
			
			.then(response => {
				const result = response.data;
				if (result.status) {
					let newState = {
						question_text: result.data.question.question_text,
						question_type: result.data.question.question_type,
						option_count: result.data.question.option.length
					};

					if (result.data.question.question_type !== 'essay') {
						if (result.data.question.question_type !== 'match') {
							newState.option = result.data.question.option.map(
								(item, i) => ({
									option_id: item.option_id,
									option_text: item.option_text,
									score: item.score
								})
							);
						}else{
							newState.option = result.data.question.option.map(
								(item, i) => ({
									option_id: item.option_id,
									option_text: item.option_text,
									option_match_text: item.option_match.text,
									score: item.score
								})
							);
						}

					}else{
						newState.score=this.state.score
					}


					this.setState(newState);
				} else {
					Alert.error(result.text);
				}

				this.setState({ isLoading: false });
			})
			.catch(error => {
				console.log(error);
				Alert.error("Gagal terhubung ke server!");
				this.setState({ isLoading: false });
			});
		}
	}

	componentDidMount() {
		this.loadData();
	}

	render() {
		
		return (
			<div className="card">
				<div className="card-header">{this.props.mode} Pertanyaan</div>
				<div className="card-block">
					{this.state.isLoading ? (
						"Memuat Data..."
					) : (
						<div className="form-horizontal animated fadeIn">
							<div className="form-group row">
								
								<div className="col-md-12">
									<DropdownView
										handleChange={this.handleChange}
										stateName="question_type"
										label="Type Soal"
										disabled={this.props.mode === 'Edit' ? true : false}
										items={[
											{ key: "single", value: "Single Option" },
											{ key: "essay", value: "Essay" }
										]}
										value={this.state.question_type}
									/>
									<div className="form-group row">
										<label className="col-md-2 form-control-label">
											Pertanyaan
										</label>
										<div className="col-md-10">
											<textarea
												label="Pertanyaan"
												name="question_text"
												className="form-control"
												placeholder="Ketik pertanyaan disini ..."
												onChange={this.handleChange}
												value={this.state.question_text}
												style={{ marginBottom: 10 }}
											/>
										</div>
									</div>
									
									{this.state.question_type === '' ? (
										""
									) : (

										this.state.question_type !== "essay"  ? (
											<DropdownView
												handleChange={this.handleChange}
												stateName="option_count"
												label="Jumlah Jawaban"
												disabled={this.props.mode === 'Edit' ? true : false}
												items={[
													{ key: "3", value: "3" },
													{ key: "4", value: "4" },
													{ key: "5", value: "5" },
													{ key: "6", value: "6" }
												]}
												value={this.state.option_count}
											/>
										) : (

											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Nilai Maksimal
												</label>
												<div className="col-md-10">
												<input
													type="number"
													name="score"
													placeholder="Nilai.."
													style={{
														padding: "3px 7px",
														border: "1px solid #ccc",
														width: "20%"
													}}
													value={this.state.score}
													onChange={this.handleChangeScoreEssay}
												/>
												</div>
											</div>
										)
									)}

									<div style={{ margin: "5px 0" }}>
										Pilihan (Pilih Satu sebagai jawaban) :
									</div>
									{	this.state.question_type === 'match' ? (
											this.state.option.map((item, i) => (
											<div
												className="checkbox"
												style={{ marginBottom: 10 }}
												key={`question-option-${i}`}
											>
												<div className="form-group row">
													<label className="col-md-2 form-control-label">
														Jawaban
													</label>
													<div className="col-md-10">
													<p>
													<input
														type="text"
														placeholder="Opsi Jawaban"
														style={{
															padding: "3px 7px",
															border: "1px solid #ccc",
															width: "50%"
														}}
														value={item.option_text}
														onChange={e => this.handleChangeOptionText(e, i)}
													/></p>
													<input
														type="text"
														placeholder="Opsi Jawaban Pasangan"
														style={{
															padding: "3px 7px",
															border: "1px solid #ccc",
															width: "50%"
														}}
														value={item.option_match_text}
														onChange={e => this.handleChangeOptionMatchText(e, i)}
													/>
													<input
														type="number"
														placeholder="Nilai.."
														style={{
															padding: "3px 7px",
															border: "1px solid #ccc",
															width: "5%"
														}}
														value={item.score}
														onChange={e => this.handleChangeOptionScore(e, i)}
													/>
													</div>
												</div>
												
											</div>
											))
										):(
										this.state.option.map((item, i) => (
										<div
											className="checkbox"
											style={{ marginBottom: 10 }}
											key={`question-option-${i}`}
										>
											<div className="form-group row">
												<label className="col-md-2 form-control-label">
													Jawaban
												</label>
												<div className="col-md-10">
												<input
													type="text"
													placeholder="Opsi Jawaban"
													style={{
														padding: "3px 7px",
														border: "1px solid #ccc",
														width: "50%"
													}}
													value={item.option_text}
													onChange={e => this.handleChangeOptionText(e, i)}
												/>
												<input
													type="number"
													placeholder="Nilai.."
													style={{
														padding: "3px 7px",
														border: "1px solid #ccc",
														width: "5%"
													}}
													value={item.score}
													onChange={e => this.handleChangeOptionScore(e, i)}
												/>
												</div>
											</div>
											
										</div>
										)))
									}
								</div>
							</div>
						</div>
					)}
				</div>
				<div className="card-footer">
					<button
						type="button"
						className="btn btn-md btn-primary"
						disabled={this.state.isButtonLoading && "disabled"}
						onClick={this.handleSubmit}
					>
						{this.state.isButtonLoading ? "Loading" : "Simpan"}
					</button>{" "}
					<button
						type="button"
						className="btn btn-md btn-danger"
						disabled={this.state.isButtonLoading && "disabled"}
						onClick={() => this.props.history.goBack()}
					>
						Batal
					</button>
				</div>
			</div>
		);
	}
}

export default Forms;



// WEBPACK FOOTER //
// ./src/views/Exam/Question/Forms.js